import React from "react";

import {
    TestimonialCarouselBlock,
    TestimonialItemBlock,
    ThemeChooserBlock,
} from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { CARD_SHAPE } from ".";
import { getThemeClass } from "../ThemedModule";

import styles from "./TestimonialCarousel.module.scss";

export const TestimonialCard = ({
    value,
    theme,
    cardShape,
}: {
    value: TestimonialItemBlock;
    theme: ThemeChooserBlock | null | undefined;
    cardShape: TestimonialCarouselBlock["card_shape"];
}) => {
    const imageType = value.image_type || "none";

    return (
        <article
            className={concatClassNames([
                styles.card,
                cardShape === CARD_SHAPE.SPEECH_BUBBLE
                    ? styles.cardRounded
                    : undefined,
                getThemeClass(theme),
            ])}
        >
            <div className={styles.cardInner}>
                <blockquote className={styles.quote}>
                    <p className={styles.quoteText}>
                        <span className={styles.openQuote} aria-hidden="true">
                            &ldquo;
                        </span>
                        {value.quote}&rdquo;
                    </p>
                </blockquote>

                <div className={styles.attribution}>
                    {value.image && imageType !== "none" && (
                        <div className={styles[`image--${imageType}`]}>
                            <ImageChooserBlock value={value.image} attrs={{}} />
                        </div>
                    )}

                    <div className={styles.attributionText}>
                        <p className={styles.name}>{value.name}</p>
                        {(value.position || value.company) && (
                            <p className={styles.positionCompany}>
                                {value.position}
                                {value.position && value.company && ", "}
                                {value.company}
                            </p>
                        )}
                        {value.lean_in_status && (
                            <p className={styles.leanInStatus}>
                                {value.lean_in_status}
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </article>
    );
};
